/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { IExposureDuration } from '../models/exposure-duration.model';

export class LoadExposureDurations {
  static readonly type = '[Exposure Duration] Load Exposure Durations via Service';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadAllExposureDurations {
  static readonly type = '[Exposure Duration] Load All Exposure Durations via Service';
}

export class LoadExposureDurationById {
  static readonly type = '[Exposure Duration] Load an Exposure Duration By Id';
  constructor(public id: string) {}
}

export class CreateExposureDuration {
  static readonly type = '[Exposure Duration] Create Exposure Duration';
  constructor(public exposureDuration: IExposureDuration) {}
}

export class UpdateExposureDuration {
  static readonly type = '[Exposure Duration] Update Exposure Duration';
  constructor(public exposureDuration: IExposureDuration) {}
}

export class DeleteExposureDuration {
  static readonly type = '[Exposure Duration] Delete Exposure Duration';
  constructor(public id: string) {}
}

export class ClearCurrentExposureDuration {
  static readonly type = '[Exposure Duration] Clear current exposure duration';
}
